import store from '@/store';
import { ElMessage } from "element-plus";
import i18n from "@/lang";

/**
 * 权限匹配
 * @param {*} idsArray  权限标识数组
 */
export function hasPermi(idsArray = []) {
  const all_permission = "*:*:*";
  const permissions = store.state.user.permissions;
  const permissionFlag = idsArray;
  return permissions.some((permission) => {
    return all_permission === permission || permissionFlag.includes(permission);
  });
}

export function getRowsFromResponse(res = {}) {
  const data = res.data ?? res;
  if (Array.isArray(data)) {
    return data;
  }
  return (
    data.rows ??
    data.records ??
    data.list ??
    res.rows ??
    res.records ??
    res.list ??
    []
  );
}

export function getTotalFromResponse(res = {}, rows = []) {
  const data = res.data ?? res;
  return Number(
    data.total ?? data.totalCount ?? data.count ?? res.total ?? rows.length,
  );
}

export function removeEmptyParams(params = {}) {
  return Object.fromEntries(
    Object.entries(params).filter(
      ([, value]) => value !== "" && value !== undefined && value !== null,
    ),
  );
}

export function normalizeNumberParam(value) {
  if (value === "" || value === undefined || value === null) {
    return "";
  }
  const numberValue = Number(value);
  return Number.isNaN(numberValue) ? value : numberValue;
}

/**
 * 复制文本到剪贴板，兼容不支持 Clipboard API 的浏览器。
 * @param {*} value 需要复制的内容
 * @returns {Promise<boolean>} 是否复制成功
 */
export async function copyText(value) {
  if (value === undefined || value === null || String(value) === "") {
    ElMessage.warning("暂无可复制内容");
    return false;
  }

  const text = String(value);
  try {
    if (globalThis.navigator?.clipboard?.writeText) {
      try {
        await globalThis.navigator.clipboard.writeText(text);
        ElMessage.success("复制成功");
        return true;
      } catch {
        // Clipboard API 可能因浏览器权限被拒绝，继续使用兼容方案。
      }
    }

    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.setAttribute("readonly", "");
    textarea.style.position = "fixed";
    textarea.style.opacity = "0";
    document.body.appendChild(textarea);
    let copied = false;
    try {
      textarea.select();
      copied = document.execCommand("copy");
    } finally {
      textarea.remove();
    }
    if (!copied) {
      throw new Error("Copy command failed");
    }
    ElMessage.success("复制成功");
    return true;
  } catch (error) {
    console.error(error);
    ElMessage.error("复制失败，请重试");
    return false;
  }
}

function getFilenameFromContentDisposition(headers = {}) {
  const disposition =
    headers["content-disposition"] || headers["Content-Disposition"] || "";
  const filenameMatch = disposition.match(/filename\*?=(?:UTF-8'')?("?)([^";]+)\1/i);
  if (!filenameMatch) {
    return "";
  }
  return decodeURIComponent(filenameMatch[2]);
}

export function fileViewing(url, res, original) {
  try {
    const headers = res?.headers || {};
    const data = res?.data;
    const filename = getFilenameFromContentDisposition(headers);

    if (data && (data instanceof Blob || data instanceof ArrayBuffer)) {
      const fileType = data.type;
      const downloadUrl = URL.createObjectURL(
        new Blob([data], { type: fileType || "application/octet-stream" }),
      );
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = original || filename || "";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setTimeout(() => URL.revokeObjectURL(downloadUrl), 1000);
      return;
    }

    if (url) {
      const link = document.createElement("a");
      link.href = url;
      link.download = original || filename || "";
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      return;
    }

    ElMessage.warning(i18n.global.t("无法查看文件：文件未上传或文件信息不完整"));
  } catch (error) {
    console.log(error);
    ElMessage.error(i18n.global.t("查看文件失败，请稍后重试"));
  }
}
